import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store/store';
import Sheet from '@amzn/meridian/sheet';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import Heading from '@amzn/meridian/heading';
import {
  setIsJobConfigFilterSheetOpen,
  setJobConfigTableFilter,
  applyJobConfigTableFilter,
  resetJobConfigTableFilter,
} from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import FilterDropdown from 'src/components/shared/filterDropdown/filterDropdown';

/**
 * Job Configuration Filter Sheet
 */
const JobConfigFilterSheet = () => {
  const dispatch = useDispatch();

  const { isJobConfigTableFilterSheetOpen, jobConfigTableFilterOptions, jobConfigTableFilter } = useAppSelector(
    (state) => state.jobConfigPage,
  );

  const close = useCallback(() => {
    dispatch(setIsJobConfigFilterSheetOpen(false));
  }, [dispatch]);

  const reset = useCallback(() => {
    dispatch(resetJobConfigTableFilter());
  }, [dispatch]);

  const apply = useCallback(() => {
    dispatch(applyJobConfigTableFilter());
    dispatch(setIsJobConfigFilterSheetOpen(false));
  }, [dispatch]);

  // Return
  return (
    <Sheet type="overlay" side="end" open={isJobConfigTableFilterSheetOpen} onClose={close}>
      <Column spacing="500" height={250} minWidth={400}>
        {/* Header */}
        <Row widths={['grid-10', 'grid-2']}>
          <Heading level={4}>Filter Job Configurations</Heading>
          <Button onClick={close} type="icon">
            <Icon tokens={closeTokens}>Close sheet</Icon>
          </Button>
        </Row>

        {/* Filters */}
        <Column spacing="400">
          {/* Job Name Filter */}
          <FilterDropdown
            label="Job Name"
            value={jobConfigTableFilter.jobNames}
            options={jobConfigTableFilterOptions.jobNames}
            onChange={(val) =>
              dispatch(
                setJobConfigTableFilter({
                  ...jobConfigTableFilter,
                  jobNames: val,
                }),
              )
            }
          />

          {/* Region Filter */}
          <FilterDropdown
            label="Region"
            value={jobConfigTableFilter.regions}
            options={jobConfigTableFilterOptions.regions}
            onChange={(val) =>
              dispatch(
                setJobConfigTableFilter({
                  ...jobConfigTableFilter,
                  regions: val,
                }),
              )
            }
          />

          {/* Type Filter */}
          <FilterDropdown
            label="Type"
            value={jobConfigTableFilter.types}
            options={jobConfigTableFilterOptions.types}
            onChange={(val) =>
              dispatch(
                setJobConfigTableFilter({
                  ...jobConfigTableFilter,
                  types: val,
                }),
              )
            }
          />

          {/* Site Type Filter */}
          <FilterDropdown
            label="Site Type"
            value={jobConfigTableFilter.siteTypes}
            options={jobConfigTableFilterOptions.siteTypes}
            onChange={(val) =>
              dispatch(
                setJobConfigTableFilter({
                  ...jobConfigTableFilter,
                  siteTypes: val,
                }),
              )
            }
          />

          {/* Is Active Filter */}
          <FilterDropdown
            label="Is Active?"
            value={jobConfigTableFilter.isActiveSelections}
            options={jobConfigTableFilterOptions.isActiveSelections}
            onChange={(val) =>
              dispatch(
                setJobConfigTableFilter({
                  ...jobConfigTableFilter,
                  isActiveSelections: val,
                }),
              )
            }
          />

          <br />
          <Row alignmentHorizontal="center">
            <Button type="secondary" onClick={reset}>
              Reset
            </Button>
            <Button onClick={apply}>Apply</Button>
          </Row>
        </Column>
      </Column>
    </Sheet>
  );
};

export default JobConfigFilterSheet;
